import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import { Grid, TextField, Typography } from '@material-ui/core'

const initialState = {
    input: {},
    base_claim_in_rounds: 0,
    random_claim_in_rounds: 0,
    dialogOpen: false,
    isLoading: false,
}

class EditContinuousLossDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditContinuousLossDialog', options)
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(inputs) {
        this.setState({
            input: inputs,
            base_claim_in_rounds: inputs['claim_in_rounds'][0],
            random_claim_in_rounds: inputs['claim_in_rounds'][1] - inputs['claim_in_rounds'][0],
            isLoading: false,
        })
    }

    OpenDialog(inputs) {
        this.reset(inputs)
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>
                    {this.t('Title', {
                        game_name: this.t('GameName.' + this.state.input.game_code),
                    })}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label={this.t('baseClaimInRounds')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.base_claim_in_rounds}
                                onChange={(event) => {
                                    let value = Math.max(event.target.value, 1)
                                    if (Number.isNaN(value)) value = 1
                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            claim_in_rounds: [value, value + this.state.random_claim_in_rounds],
                                        },
                                        base_claim_in_rounds: value,
                                    })
                                }}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={this.t('randomClaimInRounds')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.random_claim_in_rounds}
                                onChange={(event) => {
                                    let value = Math.max(event.target.value, 1)
                                    if (Number.isNaN(value)) value = 1
                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            claim_in_rounds: [this.state.base_claim_in_rounds, this.state.base_claim_in_rounds + value],
                                        },
                                        random_claim_in_rounds: value,
                                    })
                                }}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography color="error">
                                {this.state.input['claim_in_rounds'] &&
                                    this.t('TriggerRange', {
                                        min: this.state.input['claim_in_rounds'][0],
                                        max: this.state.input['claim_in_rounds'][1],
                                    })}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography style={{ whiteSpace: 'pre-line' }}>{this.t('continuousLossComment')}</Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ isLoading: true })

                            utils.apiRequest(
                                'patch',
                                API.RISKMGT_GAME_RISK_INFO,
                                {
                                    id: this.state.input.id,
                                    claim_in_rounds: this.state.input.claim_in_rounds,
                                },
                                (_data) => {
                                    this.confirm()
                                },
                                (_err) => {
                                    this.setState({ isLoading: false })
                                }
                            )
                        }}
                        color="primary"
                        disabled={this.state.isLoading}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {}
}

EditContinuousLossDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EditContinuousLossDialog)
